import React, { useContext } from "react"
import { Context } from "./../../../context/app-context"

import { siteUrl } from "../../../shared/utils/siteUrl"
import useMediaQuery from "../../../utils/useMediaQuery"
import { costActivity, numWinners } from "../../../constants/activity-constants"

import { Link } from "gatsby"

import icon20 from "../../../assets/images/icon20.png"
import icon1 from "../../../assets/images/icon1.png"
import icon2 from "../../../assets/images/icon2.png"
import icon3 from "../../../assets/images/icon3.png"
import icon4 from "../../../assets/images/icon4.png"
import iconV from "../../../assets/images/iconV.png"
import logoVNosotras from "../../../assets/images/logoVNosotras.png"

import homeCards from "../../../assets/images/home_cards.png"
import prize from "../../../assets/images/home_bodegon.png"

import "./instructions.scss"
export default function Instructions() {
  const isMobile = useMediaQuery()
  const { dispatch } = useContext(Context)

  const handleModalOpen = () => {
    dispatch({
      type: "set-context",
      payload: {
        modalActive: {
          type: "unauthenticated",
          props: {
            firstProp: 1
          }
        }
      }
    })
  }

  return (
    <div className="instructions">
      <div className="instructions__container">
        {isMobile && <img src={logoVNosotras} />}
        <div className="instructions__container-instructions">
          <section>
            {/* <img src={title} /> */}
            <h2
              className={`family-Bw-Black color-white ${
                isMobile ? "size-27" : "size-40"
              }`}
            >
              ¿CÓMO PARTICIPO?
            </h2>
            <h2 className="family-TrashHand size-42 color-white">
              <img src={icon1} alt="numeracion 1" className="imgIconNum" />
              Inicia sesión
            </h2>
            <p className="family-H-Medium size-18 color-white">
              Para comenzar debes{" "}
              <a
                onClick={handleModalOpen}
                className="family-Bw-Black size-17 underline"
              >
                Iniciar Sesión{" "}
              </a>
              con tus datos de{" "}
              <span className="color-white bold">NosotrasOnline,</span>
              <br /> si aún no estás registrada, <br /> <br /> ¡No tienes de qué
              preocuparte!
            </p>
            <a
              className="btn-primary f-concentrate-instructions-link"
              target="_blank"
              rel="noopener noreferrer"
              href={siteUrl + "/registro/"}
            >
              COMIENZA AQUÍ
            </a>
          </section>
          <section>
            <h2 className="family-TrashHand size-42 color-white">
              <img src={icon2} alt="numeracion 2" className="imgIconNum" />{" "}
              Redime puntos
            </h2>
            <div className="flex redeem">
              <p className="family-H-Medium size-18 color-white">
                Para poder jugar debes redimir{" "}
                <img src={icon20} className="imgIcon20" />, de tus <br />
                puntos acumulados. <br /> <br /> Si aún no tienes ¡puedes estar
                tranquila! <br /> Inscribe las claves de tus productos Nosotras
              </p>
              <a
                className="btn-primary f-concentrate-instructions-link"
                target="_blank"
                rel="noopener noreferrer"
                href={siteUrl + "/mis-puntos/que-son/"}
              >
                AQUÍ
              </a>
            </div>
          </section>
          <section className="playSection">
            <h2 className="family-TrashHand size-42 color-white">
              {" "}
              <img src={icon3} alt="numeracion 3" className="imgIconNum" />{" "}
              Juega
            </h2>
            <div className="flex play">
              <div>
                <p className="family-H-Medium size-18 color-white">
                  ¿Lista para jugar? <br /> <br />
                  <span className="family-Bw-Black color-white">
                    Aprende de tu Zona V,
                  </span>{" "}
                  pon a prueba tu memoria y encuentra todas las parejas del
                  Mundo Nosotras en tiempo record <br /> <br />
                  <span className="family-Bw-Black color-white">
                    Podrás ganar un calendario Nosotras y un kit es- pec - ta -
                    cu - lar
                  </span>
                </p>
              </div>
              <img src={homeCards} />
              <img src={iconV} className="iconV" />
            </div>
          </section>
          <section className="instrucciones">
            <ul className="family-H-Medium size-18 color-white">
              <li>
                <span className="family-Bw-Black color-white size-16">
                  ¡Concéntrate!
                </span>{" "}
                Pon a prueba tu memoria y <br /> encuentra todas las parejas que
                puedas.
              </li>
              <li>
                <span className="family-Bw-Black color-white size-16">
                  Serán 5 niveles,
                </span>{" "}
                en donde el número de tarjetas <br /> aumentará y el tiempo
                también. A medida que se cumpla cada nivel, el tiempo se
                reiniciará.
              </li>
              <li>
                <span className="family-Bw-Black color-white size-16">
                  Serán 5 niveles, al principio te aparecerán 4 tarjetas,
                </span>{" "}
                cuando las resuelvas, te aparecerán 6 tarjetas nuevas y después
                8, hasta completar 12.
              </li>
              <li>
                <span className="family-Bw-Black color-white size-16">
                  Ganarás 5 puntos{" "}
                </span>
                por cada tarjeta que <br /> encuentres.
              </li>
              <li>
                <span className="family-Bw-Black color-white size-16">
                  Participa las veces que quieras
                </span>{" "}
                redimiendo {costActivity} cada vez.
              </li>
            </ul>
            <span className="family-Bw-Black color-white size-25">
              ¿LISTA PARA JUGAR?
            </span>
            <button
              className="CTA btn-primary f-concentrate-instructions-btn"
              onClick={handleModalOpen}
            >
              ¡JUGAR!
            </button>
          </section>
          <section className="ganaSection">
            <h2 className="family-TrashHand size-42 color-white">
              <img src={icon4} alt="numeracion 4" className="imgIconNum" />
              GANA
            </h2>
            <div className="flex prize">
              <div>
                <span className="family-Bw-Black color-white size-20">
                  Del top 1 al {numWinners} ganarán
                </span>

                {isMobile && <img className="prizeImg" src={prize} />}
              </div>
              {!isMobile && <img className="prizeImg" src={prize} />}
              <p className="family-H-Medium size-18 color-white mb">
                <span className="family-Bw-Black color-white">
                  Un Calendario
                </span>{" "}
                <br />
                Nosotras y un kit <br />
                <span className="family-Bw-Black color-white">
                  es- pec - ta - cu - lar
                </span>
              </p>
            </div>
            <p className="family-H-Medium color-white save-package">
              Antes de jugar, conoce todos los términos y condiciones{" "}
              <Link
                className="family-Bw-Black size-16 underline"
                to={"/terminos"}
              >
                aquí
              </Link>
              <br /> <br /> Ahora sí, ¡Pon a prueba tu memoria para ganar!
            </p>
            <button
              className="CTA btn-primary f-concentrate-instructions-btn"
              onClick={handleModalOpen}
            >
              ¡QUIERO JUGAR!
            </button>
          </section>
        </div>
      </div>
    </div>
  )
}
